import React, { useRef } from 'react';
import './style.scss';
import Carousel from 'react-multi-carousel';
import btn_left from 'assets/imgs/btn-arrow-left.png';
import btn_right from 'assets/imgs/btn-arrow-right.png';

const Slide = ({ children, infinite, showArrow, numberDesktop, numberTablet, numberMobile }) => {
  let refCarousel = useRef(null);

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: numberDesktop,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: numberTablet,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: numberMobile,
    }
  };
  
  const onClickLeft = () => {
    refCarousel.previous();
  }

  const onClickRight = () => {
    refCarousel.next();
  }

  return (
    <div className="slide-wrapper mt-4">
      {showArrow && <img alt='left' src={btn_left} onClick={onClickLeft} className="icon-arrow --left" />}
      <div>
        <Carousel
          draggable={false}
          responsive={responsive}
          infinite={infinite}
          autoPlay
          autoPlaySpeed={5000}
          transitionDuration={0}
          containerClass="carousel-container"
          removeArrowOnDeviceType={["tablet", "mobile"]}
          ref={(el) => (refCarousel = el)}
          arrows={!showArrow}
        >
          {children}
        </Carousel>
      </div>
      {showArrow && <img alt='right' src={btn_right} onClick={onClickRight} className="icon-arrow --right" />}
    </div>
  )
}

Slide.defaultProps = {
  infinite: true,
  numberDesktop: 4,
  numberTablet: 3,
  numberMobile: 2
};


export default React.memo(Slide);
